import PropTypes from 'prop-types'
import React from 'react'

export default function DetailContentLayoutTemplate (props) {
  const {
    rowOne,
    rowTwo = null,
    rowThree = null,
    rowFour = null,
    rowFive = null,
  } = props
  return (
    <div className="detail-content-layout-template">
      {rowOne && (
        <div className="detail-content-layout-template__top">
          {rowOne}
        </div>
      )}
      {(rowTwo || rowThree || rowFour || rowFive) && (
        <div className="detail-content-layout-template__bottom">
          <div className="detail-content-layout-template__bottom-item">
            {rowTwo}
          </div>
          <div className="detail-content-layout-template__bottom-item">
            {rowThree}
          </div>
          <div className="detail-content-layout-template__bottom-item">
            {rowFour}
          </div>
          <div className="detail-content-layout-template__bottom-item">
            {rowFive}
          </div>
        </div>
      )}
    </div>
  )
}

DetailContentLayoutTemplate.propTypes = {
  rowOne: PropTypes.node.isRequired,
  rowTwo: PropTypes.node,
  rowThree: PropTypes.node,
  rowFour: PropTypes.node,
  rowFive: PropTypes.node,
}
